import { render, staticRenderFns } from "./Setup.vue?vue&type=template&id=1fd8c4b8"
import script from "./Setup.vue?vue&type=script&lang=ts"
export * from "./Setup.vue?vue&type=script&lang=ts"
import style0 from "./Setup.vue?vue&type=style&index=0&id=1fd8c4b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports